import { ITEM_STATUSES } from '@updater-core/constants/items';

import {
  getArrivalDate,
  getArrivalTime,
} from '@updater-apps/full-service-move/utils';

export function formData(state) {
  return state;
}

export function fsmStatus(state) {
  if (state.status && !state.booked) {
    return ITEM_STATUSES.PENDING;
  }
  return state.booked === true ? ITEM_STATUSES.COMPLETED : state.status;
}

export function bookedTime(state) {
  return getArrivalTime(`${state.fsmAppointmentId}`);
}

export function bookedDate(state) {
  return getArrivalDate(
    `${state.fsmAppointmentId}`,
    state.availableAppointments
  );
}

export function fsmCardConfig() {
  return {};
}

export function isEligibleForFsm(state): boolean {
  return state?.eligible || false;
}
